import { messagesForParent } from '@b2ag/micro-front-tools'
import type { DataForParent } from '@b2ag/micro-front-tools'
import { useTargetMembership } from '@b2ag/membership/src/composables/useTargetMembership'

function callbackChangeShoppingList({ shoppingListId }: { shoppingListId: string }) {
  const targetMembership = useTargetMembership()

  targetMembership.updateTargetShoppingListId(
    {
      shoppingListId,
    },
    false,
  )
}

export function callbacksFromShoppingListMicroFrontIframe({ message, data }: DataForParent) {
  const shoppingListId: string = data?.shoppingListId

  switch (message) {
    case messagesForParent.CHANGE_SHOPPING_LIST:
      callbackChangeShoppingList({ shoppingListId })
      break
    default:
      break
  }
}
